import { moduleStyleType } from 'components/no-ui/styles/styleTypes'

export const CheckBoxGroupStyles: moduleStyleType = {
    fieldLabel: {
        margin: 2,
    },
}
